<template>
    <div class="about_menu_top  textalign_left">
        <div style="background: #fff;max-width: 1920px;margin: 0 auto;"  class="ms-controller">
            <div style="margin: 0 auto;">
                <div style="height: 8603px;background: url('http://p1.fishqc.net/FifFejBnzN8dbcHVtGiXKMFYSmAD') center center no-repeat;background-size: auto 100%;padding-top: 497px;box-sizing: border-box;">
                    <div style="width:1054px;margin:0 auto;display:block;position: relative;font-size:36px;font-family:PingFang SC;color:533727;height: 100%;text-align: center;">
                        <div class="descbox">
                            315一天的放心，是远远不够的。365天的安心，才是我们想要的。小鱼让你315不踩雷，选好放心优品安心每一天。
                        </div>
                        <div v-for="item in productdata">
                            <div class="padding_top_60">
                                <img :src="item.typeImg">
                            </div>
                            <div class="typeItem">
                                {{item.dec}}
                                <img src="http://p1.fishqc.net/FgzbpmuZst-kw-yHrPcfK94rVFyt" class="typeItem_bg">
                                
                            </div>
                            <div class="productItem_315" v-for="val in item.section">
                                <div class="productItem_type_title">{{val.title}}</div>
                                <div class="productItem_type_desc">{{val.destext}}</div>
                                <div class="display_flex justify-content_flex-justify" style="padding:0 62px 50px;box-sizing: border-box;">
                                    <div class="double12_product display_flex flex-wrap_wrap " v-for="itemindex in val.product"  @click="toproductdetail(itemindex.type,itemindex.id)">
                                        <div class="double12_img">
                                            <div class="product_img" :style="{backgroundImage: 'url('+ itemindex.img + ')'}">
                                                <img class="greenfish" src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK">
                                            </div>
                                            
                                        </div>
                                        <div class="double12_producttxt flex_1">
                                            <div>{{itemindex.brand}}</div>
                                            <div class="producttxt_name">{{itemindex.title}}</div>
                                            <div class="tips_padding">
                                                <span class="double12_tips">{{itemindex.tips}}</span>
                                            </div>
                                            <div>
                                                <span class="double12_address">品牌所在地：{{itemindex.address}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div style="padding-top: 20px;box-sizing: border-box;">
                            <img src="http://p1.fishqc.net/Fqo2Z6wMtxAy9TOdPffaq2UtBCNV">
                        </div>
                        <div style="padding-top: 100px;box-sizing: border-box;">
                            <img src="http://p1.fishqc.net/Fiqplwa00FMo6aQNaEMUuccD0jmN">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.about_menu_top {
    margin: 100px auto 0;

}
.fangyicontain {
    font-size: 0;
}

.mumcontain{
    width: 1054px;
    margin:0 auto;
    display: block;
    text-align: center;
    /*padding-top: 1937px;*/
    
}
.muntitle{
    font-size:32px;
    font-family:Songti SC;
    font-weight:900;
    color:rgba(255,255,255,1);
    line-height:43px;
    text-shadow:0px 3px 8px rgba(255,117,131,0.3);
    padding:0 20px;
    vertical-align: middle;
}

.verticalalign-middle{
    vertical-align: middle;
}

.munbox{
    width:100%;
    background:#FFF7F5;
    border-radius:24px;
    padding:0 32px 60px;
    margin-bottom: 60px;

}


.munbox:last-child{
    margin-bottom: 0px;
}
.producttype{
    display:inline-block;
    width:178px;
    height:48px;
    line-height: 48px;
    color:#fff;
    font-size:24px;
    text-align:center;
    border-bottom-left-radius:42px;
    border-bottom-right-radius:42px;
    background: -webkit-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -o-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -moz-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -ms-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -webkit-gradient(linear, 0% 100%, from(rgba(254,99,72,1)), to(rgba(255,139,119,1)));
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(254,99,72,1)), color-stop(100%,rgba(255,139,119,1)));
    background:linear-gradient(0deg,rgba(254,99,72,1),rgba(255,139,119,1));
    box-shadow: 0px 0px  8px #FFAD9D;
}

.gradient{
    background: #000000;
    background: -moz-linear-gradient(top,  #000000 0%, #ffffff 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#000000), color-stop(100%,#ffffff));
    background: -webkit-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -o-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -ms-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: linear-gradient(to bottom,  #000000 0%,#ffffff 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#ffffff',GradientType=0 );
}
.dec{
    padding:24px 0;
    box-sizing:border-box;
    color:#444a46;
    font-size:24px;
    line-height: 24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(80,79,75,1);
}

.dec-text{
    font-size:18px;
    color:#494947;
    line-height:30px;
    text-indent:3px;
    text-align:left;
    padding:20px 32px;
    background-color:#fff;
    border-radius:20px;
    position:relative;
    margin-bottom: 35px;
    
}
.tips{
    width: 174px;
    height:36px;
    line-height:36px;
    background-color:#45ccbe;
    box-sizing:border-box;
    position:absolute;
    bottom:-20px;
    right:0;
    border-bottom-right-radius:20px;
    border-top-left-radius:20px;
    text-align: center;
    
}
.tipstext{
    display:inline-block;
    font-size:24px;
    color:#fff;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(225,251,248,1);
}

.productdetailcontain{
    width: 273px;
    margin-right: 60px;
    display: inline-block;
    background-color: #fff;
    border-radius:24px;
    height: 402px;
    vertical-align: top;
    /*margin-bottom: 32px;*/
    cursor: pointer;
    padding:0 40px 0;
    box-sizing: border-box;
    box-shadow: 0px 0px 24px rgba(255,117,131,0.06);

}
.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
}

.productdetailcontain:nth-of-type(3n){
    margin-right: 0px;
}

.imgcontain{
    width:100%;
    height: 100%;
    display: inline-block;
    text-align:center;
    position: relative;
    overflow: hidden;
}
.center{
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%, -50%);
}
.greenfish{
    position:absolute;
    right:14px;
    bottom:0px;
}
.class1{
    height: 130%;
    /*width:238px;*/
}
.class2{
    height: 100%;
    /*width:120px;*/
}
.class3{
    height: 100%;
    /*width:157px;*/
}
.class4{
    /*width:218px;*/
    height: 114%;
}
.class5{
    /*width:140px;*/
    height: 100%;
}
.class6{
    /*width:106px;*/
    height: 100%;
}
.class7{
    /*width:119px;*/
    height: 100%;
}
.class8{
    /*width:200px;*/
    height: 100%;
}
.class9{
    /*width:200px;*/
    height: 120%;
}
.class10{
    /*width:210px;*/
    height: 120%;
}

.class11{
    /*width:82px;*/
    height: 100%;
}
.class12{
    /*width:110px;*/
    height: 100%;

}
.class13{
    /*width:172px;*/
    height: 100%;
}
.class14{
    /*width:128px;*/
    height: 100%;
}
.class15{
    /*width:76px;*/
    height: 100%;

}
.class16{
    /*width:158px;*/
    height: 112%;
}

.flex-one{
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}
.brandcover{
    padding:20px 0 10px;
}

.band{
    
    font-size:24px;
    line-height: 26px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(80,79,75,1);
}

.title{
    font-size:18px;
    line-height: 24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(80,79,75,1);
    padding-bottom: 20px;
}

.detail-tips{
    padding:0 12px;
    height:30px;
    background:rgba(210,242,238,1);
    border-radius:12px 0px 12px 0px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(68,204,189,1);
    line-height: 30px;
    display:inline-block;
    text-align: center;

}
.address{
    padding-top: 16px;
    font-size:16px;
    line-height: 16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(121,121,121,1);
}

.techcontain{
    width: 1054px;
    margin:0 auto;
    display: block;
    text-align: center;
}
.heightclass1{
    height: 392px;
}
.heightclass2{
    height: 392px;
    margin-right:0;
}
.heightclass3{
    height: 470px;
}

.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    height: 256px;
}

.derection-column{
    flex-direction: column;
    -webkit-flex-direction: column;
}

.display_flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
}

/*.display_flex > *{
     display: block;
 }*/
.display_inline-flex {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: -webkit-inline-flex;
    display: inline-flex;
}


/*伸縮流方向*/
.flex-direction_column {
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
}

/*主軸對齊*/
.justify-content_flex-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
}

.justify-content_flex-end {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
}

.justify-content_flex-justify {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}

/*側軸對齊*/
.align-items_flex-start {
    -webkit-box-align: start;
    -ms-flex-align: start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
}

.align-items_flex-end {
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
}

.align-items_center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.align-items_baseline {
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    -webkit-align-items: baseline;
    align-items: baseline;
}

.align-items_space_between {
    -webkit-box-align: space-between;
    -ms-flex-align: space-between;
    -webkit-align-items: space-between;
    align-items: space-between;
}

.horizontal-between {
    justify-content: space-between;
    -webkit-justify-content: space-between;
}

/*伸縮性*/
.flex_auto {
    -webkit-box-flex: 1;
    -ms-flex: auto;
    -webkit-flex: auto;
    flex: auto;
}

.flex_1 {
    width: 0;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}

.flex_2 {
    width: 0;
    -webkit-box-flex: 2;
    -ms-flex: 2;
    -webkit-flex: 2;
    flex: 2;
}


.flex-wrap_wrap {
    flex-wrap: wrap;
}
.padding-top-495 {
    padding-top: 495px;
}

.double11_head {
    width: 1000px;
    box-sizing: border-box;
    font-size: 26px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FEAE50;
    line-height: 48px;

    background-color: #fff;
    text-align: center;
    letter-spacing: 2px;
    position: relative;
    z-index: 2;
    margin: 0 auto;
}

.double11_back {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0);
    width: 958px;
    height: 70px;
    background-image: url('http://p1.fishqc.net/Fnbl0MTCI_lcZufbh51TuOICg5-u');
    background-repeat: no-repeat;
    background-position: center center;

}

.font-weight-bold {
    font-weight: bold;


}

.padding-top-46 {
    padding-top: 46px;
    text-align: center;
}

.double11_desc1 {
    padding-top: 14px;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
}

.double11_bg {
    width: 1078px;
    background-image: url('http://p1.fishqc.net/FrSI1Mebdl0WDMyxfdhmR0g89YMC');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
}

.double11_list {
    width: 1000px;
    margin-top: 82px;
    background-color: #fff;
    padding: 26px 30px 50px;
    box-sizing: border-box;
    z-index: 2;
    display: inline-block;
    position: relative;
}

.shadow-bottom {
    position: absolute;
    bottom: 30px;
    left: 0;
    z-index: 1
}

.double11_txt {
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #544F4D;
    text-align: center;
    line-height: 48px;
    text-align: left;
}

.double11_item {
    width: 454px;
    height: 161px;
    background: #FFFFFF;
    border: 1px solid #EEEAF0;
    margin-right: 27px;
    display: inline-block;
    margin-top: 20px;
    cursor: pointer;
}

.double11_item:nth-of-type(2n) {
    margin-right: 0;
}

.double11_item:nth-of-type(1) {
    margin-top: 6px;
}

.double11_item:nth-of-type(2) {
    margin-top: 6px;
}

.double11_list2 {
    margin-top: 92px;
    line-height: 48px;
    text-align: left;
}

.double11_list2 .double11_txt {
    text-align: left
}

.padding-top-110 {
    padding-top: 110px;
    text-align: center;
}

.double11_item_left {
    width: 160px;
    height: 100%;
    position: relative;
    display: inline-block;
    vertical-align: top;
}

.double11_item_left .productimg {
    width: 140px;
    position: absolute;
    left: 40%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.double11_item_right {
    width: 280px;
    height: 100%;
    display: inline-block;
    position: relative;
    padding-right: 20px;
    box-sizing: border-box;

}

.double11_item_right .title {
    padding-top: 25px;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #3F3E3A;
    line-height: 30px;
    padding-bottom: 18px;
    text-align: left;
}

.double11_address {

    font-size: 17px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #666666;
    line-height: 17px;
}

.double11_label {
    width: 98px;
    height: 30px;
    background: #FDF2E3;
    text-align: center;
    line-height: 30px;

    font-size: 17px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #FEAE82;
}

.greenfish {
    width: 64px;
    height: 64px;
    position: absolute;
    bottom: 10px;
    right: 10px;
}

.double_top_title {
    position: absolute;
    top: -52px;
    left: 50%;
    transform: translate(-50%, 0);
}
/**/
.descbox{
    height: 138px;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 4px #93eee0;
    border-radius: 24px;
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #3844BA;
    line-height: 44px;
    padding: 24px 130px 0 100px;
    box-sizing: border-box;
    text-align: left;
}

.padding_top_60{
    padding-top: 60px;
    box-sizing: border-box;
}

.typeItem{
    height: 138px;
    background: #355CD0;
    box-shadow: 0px 0px 6px 4px #93eee0;
    border-radius: 24px;
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #FEFFFF;
    line-height: 44px;
    text-align: left;
    padding:24px 116px 0 102px;
    box-sizing: border-box;
    position: relative;
}
.typeItem_bg{
    position: absolute;
    width:1116px;
    height: 121px;
    background: url('http://p1.fishqc.net/FgzbpmuZst-kw-yHrPcfK94rVFyt');
    background-size: contain;
    background-repeat: no-repeat;
    left: -56px;
    top: -78px;
}
    
.productItem_315{
    background: #EDFFFC;
    box-shadow: 0px 0px 8px 1px rgba(83, 116, 215, 0.29);
    border-radius: 24px;
    position: relative;
    margin-top: 78px;
    padding-top:52px;
    box-sizing: border-box;
    box-shadow: 0px 0px 12px 20px #24409314;
}

.productItem_type_title{
    width: 335px;
    height: 62px;
    background-image: url('http://p1.fishqc.net/FsFAr9gnZ3fl22TIaTazjL7T3LRS');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    line-height: 62px;
    text-align: center;
    position: absolute;
    left:50%;
    top:-31px;
    transform: translate(-50%,0);
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #3844BA;
}

.productItem_type_desc{
    width: 936px;
    margin:0 auto 30px;
    background: #FFFFFF;
    box-shadow: 0px 0px 9px 0px rgba(115, 228, 209, 0.21);
    border-radius: 16px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    line-height: 30px;
    padding:18px 32px 14px;
    box-sizing: border-box;
    text-align: left;
    box-shadow: 0px 0px 12px 5px #73e4d12e;
}

.double12_product{
    width: 454px;
    height: 254px;
    background: #FFFFFF;
    box-shadow: 0px 1px 8px 0px rgba(205, 247, 218, 0.7);
    border-radius: 24px;
    cursor: pointer;
    box-shadow: 0px 0px 12px 5px #73e4d12e;
}

.double12_producttxt{
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #58BA96;
    text-align: left;
    padding-top: 40px;
    box-sizing: border-box;

    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #3844BA;
    line-height: 26px;
}

.double12_address{

    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    line-height: 43px;
}

.double12_img{
    width: 154px;
    width: 200px;
    height: 254px;
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;

}
.tips_padding{
    padding-top: 50px;
    padding-bottom: 24px;
    box-sizing: border-box;
}
.double12_tips{
    line-height: 16px;
    font-size: 16px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #44CCBD;
    padding:6px 14px;
    box-sizing: border-box;
    background: #D2F2EE;
    opacity: 0.7;
    border-radius: 16px 0px 16px 0px;
    
}

.decclass{
    width: 880px;
}
.decclass1{
    width: 660px;
}
.greenfish{
    width: 88px;
    height: 88px;
    position: absolute;
    bottom: 24px;
    right: 0px;

}
.producttxt_name{
    font-size: 18px;
    line-height: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    padding-top: 10px;
    box-sizing: border-box;
}

.product_img{
    width: 154px;
    height: 205px;
    margin-top: 30px;
    margin-left:20px;
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            productdata: [{
                typeImg: 'http://p1.fishqc.net/FuybNnxJkePLF4Kqu8E2BvKq9yk7',
                dec: '女生们最关心的肯定是护肤品和化妆品，稍有不慎不仅伤害皮肤，更影响身体健康，认准绿鱼，健康和美都要有。',
                decclass: 'decclass',
                section: {
                  '1': {
                    title: '卸妆',
                    destext: '彩妆残留堵塞毛孔，容易伤害皮肤，选择干净有效且安全温和的卸妆产品，才是对自己面部肌肤最好的呵护。',
                    titleImg: 'http://p1.fishqc.net/Fv7QTCkr43sqlKboOGLYVQANOIvt',
                    product: [{
                        img: 'http://p1.fishqc.net/FoEUVYpgAK_WJ_cr7xnZZecBwbRl',
                        brand: "BIFESTA缤若诗",
                        title: '绿茶紧致清爽卸妆液',
                        tips: '网红力荐',
                        address: '日本',
                        type: 'cosmetic',
                        id: 'cT4zIANccCC0PVRIXcpNGA',
                      },
                      {
                        img: 'http://p1.fishqc.net/Fsn28zsqIlCSSU_ZV8kiNExvsS5K',
                        brand: "SHU UEMURA植村秀",
                        title: '绿茶新肌洁颜油',
                        tips: '畅销经典',
                        address: '日本',
                        type: 'cosmetic',
                        id: 'MZzspQXH1NxoM6Qyx2i9Ug',
                      }
                    ]
                  },
                  '2': {
                    title: '面膜',
                    destext: '面膜覆盖皮肤角质层，为角质层提供水分，柔软角质层，促进有效成分经皮肤吸收。安全绿鱼面膜更是精致女孩们的挚爱单品。',
                    titleImg: 'http://p1.fishqc.net/FsHHmdSdJ7t-dymp6aFDZWSb32Wf',
                    product: [{
                        img: 'http://p1.fishqc.net/Fjg39p3ShekHttPTf_lOPHXiYTlg',
                        brand: "PAPARECIPE春雨",
                        title: '蜂蜜面膜',
                        tips: '人气热销',
                        address: '韩国',
                        type: 'cosmetic',
                        id: 'OTTdypAzTMR_2P3YpVG3mA',
                      },
                      {
                        img: 'http://p1.fishqc.net/Fn9Oac3uLVP0HcT9BYeU0Y2q7lE7',
                        brand: "AHC",
                        title: '臻致维生素C面膜',
                        tips: '提亮肤色',
                        address: '韩国',
                        type: 'cosmetic',
                        id: 'Jto1Lma5F8oKLc74DgSIFA',
                      }
                    ]
                  },
                  '3': {
                    title: '防晒',
                    destext: '日晒与紫外线，不仅会引起皮肤损伤，黑色素沉着，更重要是使皮肤老化。春夏面部防护，绿鱼防晒霜常备。',
                    titleImg: 'http://p1.fishqc.net/Fi_8oOUFznm7ZRN59gZMARdf7cA5',
                    product: [{
                        img: 'http://p1.fishqc.net/FuMtnB3sCLU6gEo90Y9GrwGci99W',
                        brand: "ANESSA安热沙",
                        title: '金钻防晒露',
                        tips: '口碑之选',
                        address: '日本',
                        type: 'cosmetic',
                        id: 'cB2FgmQEHHzA32fRRt1_Tw',
                      },
                      {
                        img: 'http://p1.fishqc.net/Ftc4YBCT9AiajHfjL8isBiqYJB2a',
                        brand: "ISDIN怡思丁",
                        title: '多维光护沁融水感防晒液',
                        tips: '水感清透',
                        address: '西班牙',
                        type: 'cosmetic',
                        id: 'pENF2Fy8G-uql2Q_xux6rQ',
                      }
                    ]
                  },
                },
              },
              {
                typeImg: 'http://p1.fishqc.net/FmmGzjK4oInWggS9IryhYl7ocU7Q',
                dec: '而长辈们更关心的则是生活必需品和食品类的安全问题，绿鱼优品品质卓越，长辈们才放心。',
                decclass: 'decclass1',
                section: {
                  '1': {
                    title: '食用油',
                    destext: '食用劣质食用油可能会对身体健康造成危害，严重会产生疾病，甚至有致癌风险，跟着绿鱼榜单选，全家安心。',
                    titleImg: 'http://p1.fishqc.net/FuWL9ZO7mNlpVc4leDVKwsU8yOmL',
                    product: [{
                        img: 'http://p1.fishqc.net/Fg4KAbVitdU-_RL0QPIplnbEdt09',
                        brand: "KNIFE刀唛",
                        title: '特级香醇花生食油',
                        tips: '浓香营养',
                        address: '中国香港',
                        type: 'food',
                        id: 'E-1JzFvKQXA9sAN8FkTaFg',
                      },
                      {
                        img: 'http://p1.fishqc.net/FnfdE5k6Blh079SRkLizXZCTZF2d',
                        brand: "BERTOLLI百得利",
                        title: '清淡橄榄油',
                        tips: '清淡健康',
                        address: '意大利',
                        type: 'food',
                        id: '5c7Bbu_sv1Nuip6BY3hkqw',
                      }
                    ]
                  },
                  '2': {
                    title: '大米',
                    destext: '大米是最基础也是最重要的日常主食，但劣质大米是健康杀手，对身体有极大危害。食用安全大米是对自己的健康负责。',
                    titleImg: 'http://p1.fishqc.net/FkRe5kUz2AUNDkX2t8Mkb_LgeZYV',
                    product: [{
                        img: 'http://p1.fishqc.net/FsgqZM-keLHaN8vN5veUArwbuZcs',
                        brand: "ARAWANA金龙鱼",
                        title: '盘锦大米',
                        tips: '细腻绵长',
                        address: '中国',
                        type: 'food',
                        id: '1-DuLoodOV9JeSeRuVFiNQ',
                      },
                      {
                        img: 'http://p1.fishqc.net/FiQaKqPaRAy2cwKHTgHB0ewwzUbx',
                        brand: "AKITAKOMACHI秋田",
                        title: '珍珠米',
                        tips: '香甜软糯',
                        address: '日本',
                        type: 'food',
                        id: 'p9ub8TaoQCB-ZKyGN0EKNw',
                      }
                    ]
                  },
                  '3': {
                    title: '钙片',
                    destext: '老年人缺钙是引起骨质疏松的重要原因，除了改善饮食结构外，也需适量服用钙片。认准绿鱼，健康有保障。',
                    titleImg: 'http://p1.fishqc.net/FpA837KFuEHwNND9PeZIKgfjGo3v',
                    product: [{
                        img: 'http://p1.fishqc.net/FpjPfqrsOSIS5HL3xgaWsVLO_jxQ',
                        brand: "GNC健安喜",
                        title: '高含量钙片1000mg',
                        tips: '富含高钙',
                        address: '美国',
                        type: 'food',
                        id: 'yIO8Zliupd7oMIl6hXA_yg',
                      },
                      {
                        img: 'http://p1.fishqc.net/Ft9Phz_aVjUgIqbKSwdgT34kJCQF',
                        brand: "OSTELIN奥斯特林",
                        title: '维生素D & 钙片',
                        tips: '全家共享',
                        address: '澳大利亚',
                        type: 'food',
                        id: 'QntuYYjPtPiW7xY9NlBJxg',
                      }
                    ]
                  },
                },
              },
              {
                typeImg: 'http://p1.fishqc.net/FjWeaqfLAmW89PSxXjKp70c5uaXG',
                dec: '315晚会曝光的母婴用品也屡见不鲜，孩子用品安全第一位，选择绿鱼优品安全才更安心。',
                decclass: 'decclass1',
                section: {
                  '1': {
                    title: '牛奶',
                    destext: '孩子多喝牛奶可以满足发育所需，增强免疫力。但劣质牛奶不仅卫生和营养不达标，还会影响生长发育，认准绿鱼不掉坑。',
                    titleImg: 'http://p1.fishqc.net/FuopIXWSKPbGArNYS_ymRKueIu0m',
                    product: [{
                        img: 'http://p1.fishqc.net/FtD5w_H4d_YNFhKVmFyN0rakzpKI',
                        brand: "YILI伊利",
                        title: '金典 纯牛奶',
                        tips: '经典选择',
                        address: '中国',
                        type: 'food',
                        id: '4BQB97wbZkCkFxxMkwQlbw',
                      },
                      {
                        img: 'http://p1.fishqc.net/FjdmxvcEZAii-c9ofh6NiHJTld29',
                        brand: "SUNSIDES上质",
                        title: '全脂牛奶',
                        tips: '早餐常备',
                        address: '德国',
                        type: 'food',
                        id: 'LTBz2YFJ18CHlsI_J4ryJg',
                      }
                    ]
                  },
                  '2': {
                    title: '湿纸巾',
                    destext: '“毒”湿巾事件频频曝出，使用劣质湿纸巾不仅伤害肌肤，还会影响身体健康，为了孩子的健康更要选择安心的绿鱼产品。',
                    titleImg: 'http://p1.fishqc.net/FqbEhtKmdYrqvU-vurtTSMV-VuH-',
                    product: [{
                        img: 'http://p1.fishqc.net/Fpy6ynkRfFz7E2J5voEwQ5PYcKxM',
                        brand: "NUK",
                        title: '超厚特柔婴儿湿巾',
                        tips: '厚实柔韧',
                        address: '德国',
                        type: 'cosmetic',
                        id: 'D-gqI-3K4G1ZDGXoEF-TeQ',
                      },
                      {
                        img: 'http://p1.fishqc.net/Fl2u5n0RrH8peYuuNaVb8goKDzqo',
                        brand: "PIGEON贝亲",
                        title: '婴儿水润洁肤巾',
                        tips: '舒适亲肤',
                        address: '日本',
                        type: 'cosmetic',
                        id: 'j0uoA0G32vu6eHV1tgJWfA',
                      }
                    ]
                  },
                  '3': {
                    title: '儿童洗浴',
                    destext: '孩子的皮肤薄，比较敏感，很容易受到洗护产品的刺激，引起过敏性反应。选择安全绿鱼产品，有效保护宝宝皮肤。',
                    titleImg: 'http://p1.fishqc.net/FqA1WqBkGvWCB88akzmBFruBCS7O',
                    product: [{
                        img: 'http://p1.fishqc.net/FqA1WqBkGvWCB88akzmBFruBCS7O',
                        brand: "SEBAMED施巴",
                        title: '儿童洗发露',
                        tips: '轻柔呵护',
                        address: '德国',
                        type: 'cosmetic',
                        id: '2qvtDimQn_MtZzPwmhZ4BA',
                      },
                      {
                        img: 'http://p1.fishqc.net/FgygLkSmrqXakujBzaQNj0QH-QcB',
                        brand: "AVEENO艾惟诺",
                        title: '婴儿洗发沐浴液',
                        tips: '温和洗护',
                        address: '美国',
                        type: 'cosmetic',
                        id: 'JBIa21X5YRRGF00hdDVfOQ',
                      }
                    ]
                  },
                },
              }

            ],
        }

    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        // var position  =  this.$route.query.position
        // this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
    },
    methods: {
        scrollTo(position) {
            var that = this;
            var scroll_H;
            this.$nextTick(function() {
                if (position == 'greenrank') {
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                } else {
                    scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        toproductdetail(type,prdid){
            this.$router.push({
                path: '/product/'+type+'/'+prdid
            })
            
        }
    }
}
</script>